<template>
  <section id="welcome">
    <section
      id="home"
      :style="height"
    >
      <div id="artist-name">
          <div id="anita-kucharczyk"><h1>Anita Kucharczyk.</h1></div>
      </div>
      <div id="intro">
        <div id="based">
          SoCal visual artist
        </div>
      </div>
      <div 
        id="nav" 
        class="fade-in-1"
        :style="height"
      >
        <div id="nav-about">
          <router-link 
            class="link" 
            :to="'about'"
          >
            About
          </router-link>
        </div>
        <div id="nav-projects">
          <router-link 
            class="link" 
            :to="'#projects'"
            v-scroll-to="'#projects'"
          >
            Projects
          </router-link>
        </div>
        <div id="nav-contact">
          <router-link 
            class="link" 
            :to="'contact'"
          >
            Contact
          </router-link>
        </div>
      </div>
    </section>
    <ProjectsSection />
    <FooterComp />
  </section>
</template>

<script setup>
import { ref, computed} from 'vue'
import ProjectsSection from './ProjectsSection.vue'
import FooterComp from './FooterComp.vue'
const windowHeight = ref(document.documentElement.clientHeight)

const height = computed(() => `height: ${windowHeight.value}px`)

</script>

<style lang="scss" scoped>
  #welcome {
    #home {
      width: 100%;
      max-width: $breakpoint-max;
      display: flex;
      flex-direction: column;
      position: relative;

      #artist-name {
        flex-grow: 1;
        padding: $padding-nav * 1.5 $padding-nav 0 $padding-nav;
        max-width: $breakpoint-max;
        display: flex;
        animation: $anim-slide-from-btm-0;

        #anita-kucharczyk {
          position: relative;
          max-width: $breakpoint-max;
          background: url('../assets/svg/anita-kucharczyk.svg') no-repeat;
          background-size: contain;
          width: 100%;
          height: 100%;
          transition: all 1s;

          h1 {
            display: none;         
          }
        }
      }

      #intro {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 100;
        
        #based {
          font-family: $Light;
          font-size: clamp(1.8rem, 6vw, 3rem);
          text-align: center;
          padding: 0 1rem;
          animation: $anim-slide-from-top-2;
          max-width: 90%;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;

          &::after {
            content: "focused on light.";
            display: block;
            width: 100%;
            margin-top: 0.2em;
            font-size: 0.9em;
          }
        }
      }

      #nav {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin: 0 auto;
        width: 100%;
        max-width: $breakpoint-max;
        z-index: 200;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);

        .link {
          border-bottom: $white-border-bottom;
          padding-bottom: $padding-link;
          font-size: 30px;
          transform: scale(1);
          transition: 0.5s all;
          cursor: pointer;

          &:hover {
            color: $dark;
            transition: 0.3s all;
            border-bottom: $border-link;
          }

          &:active {
            transform: scale(0.9);
            transition: 0.5s all;
          }
        }
        
        #nav-about {
          grid-column-start: 2;
          grid-column-end: 3;
          display: flex;
          justify-self: flex-end;
          align-self: start;
          padding: $padding-nav $padding-nav 0 0;
        }

        #nav-projects {
          align-self: end;
          padding: 0 0 $padding-nav $padding-nav;
        }

        #nav-contact {
          justify-self: flex-end;
          align-self: end;
          padding: 0 $padding-nav $padding-nav 0;
        }
      }
    }
  }

  @media screen and (max-width: $breakpoint-xxl) {
    #welcome {
      #home {
        #artist-name {
          #anita-kucharczyk {
            position: absolute;
            width: calc(100% - 110px);
            margin: 50px 0 0 0;
            transition: all 1s;
          }
        }
      }
    }
  }

  @media screen and (max-width: $breakpoint-md) {
    #welcome {
      #home {
        #artist-name {
          width: calc(100% - 40px);
          height: 0%;
          padding: $padding-nav-mobile $padding-nav-mobile 0 $padding-nav-mobile;

          #anita-kucharczyk {
            background: url('../assets/svg/anita-kucharczyk-mobile.svg') no-repeat;
            margin: 0;
            width: 90%;
            height: 100%;

            h1 {
              opacity: 0;
            }
          }
        }

        #intro {
          #based {
            font-size: clamp(1.8rem, 7vw, 2.5rem);
          }
        }

        #nav {
          .link {
            font-size: 20px;
          }
          #nav-about {
            padding: $padding-nav-mobile $padding-nav-mobile 0 0;
          }
          #nav-projects {
            padding: 0 0 $padding-nav-mobile + 20px $padding-nav-mobile;
          }
          #nav-contact {
            padding: 0 $padding-nav-mobile $padding-nav-mobile + 20px 0;
          }
        }
      }
    }
  }
</style>